import { render, staticRenderFns } from "./NeoPageLayout.vue?vue&type=template&id=36d5c3bb&scoped=true&"
import script from "./NeoPageLayout.vue?vue&type=script&lang=js&"
export * from "./NeoPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./NeoPageLayout.vue?vue&type=style&index=0&id=36d5c3bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5c3bb",
  null
  
)

export default component.exports